import typeahead from 'typeahead-standalone'

const { jQuery: $ } = window

class UMC_Autocomplete_Lookup {
	constructor(opts) {
		this.formId = opts.formId
		this.fieldId = opts.fieldId
		this.lookupUrl = opts.lookupUrl
		this.init()
	}

	init() {
		typeahead({
			input: $('#input_' + this.formId + '_' + this.fieldId)[0],
			minLength: 2,
			highlight: true,
			hint: false,
			source: {
				identifier: 'departmentDescription',
				remote: {
					url: this.lookupUrl,
					wildcard: '%QUERY',
				},
				transform: data => {
					return data.options
				},
			},
		})
	}
}

UMC_Autocomplete_Lookup.instances = {}

window.UMC_Autocomplete_Lookup = UMC_Autocomplete_Lookup
